module.exports = __webpack_public_path__ + "static/media/hu.c2882f46.jpg";